import * as React from 'react';
import * as Classes from '../common/classes';
import { ElementOf, IProps, tuple } from '../common/props';
import classNames from 'classnames';
import { CSSProperties } from 'react';

export const SpaceSizes = tuple('1', '2', '3' /*, '4', '5'*/);
export type SpaceSize = ElementOf<typeof SpaceSizes>;

export interface ISpaceProps extends IProps {
  vertical?: boolean;
  wrap?: boolean;
  /**
   * Velikost mezery, pokud je uvedena jedna hodnota, je pro horizontální a vertiální mezeru použita stejná hodnota, pokud je uvedeno pole, první je horizontální, druhá vertiální - typicky pro variantu wrap.
   */
  size?: SpaceSize | [SpaceSize, SpaceSize];
  style?: CSSProperties;
}

export type SpaceProps = ISpaceProps;

export class Space extends React.PureComponent<SpaceProps> {
  render() {
    const {
      className,
      vertical,
      style,
      wrap,
      size = '1',
      ...other
    } = this.props;

    let hs;
    let vs;
    if (Array.isArray(size)) {
      hs = size[0];
      vs = size[1];
    } else {
      hs = size;
      vs = size;
    }

    return (
      <div
        style={style}
        {...other}
        className={classNames(className, Classes.SPACE, {
          [Classes.SPACE_HSIZE_1]: hs === '1',
          [Classes.SPACE_HSIZE_2]: hs === '2',
          [Classes.SPACE_HSIZE_3]: hs === '3',
          // [Classes.SPACE_HSIZE_4]: hs === '4',
          // [Classes.SPACE_HSIZE_5]: hs === '5',
          [Classes.SPACE_VSIZE_1]: vs === '1',
          [Classes.SPACE_VSIZE_2]: vs === '2',
          [Classes.SPACE_VSIZE_3]: vs === '3',
          // [Classes.SPACE_VSIZE_4]: vs === '4',
          // [Classes.SPACE_VSIZE_5]: vs === '5',
          [Classes.SPACE_VERTICAL]: vertical,
          [Classes.SPACE_HORIZONTAL]: !vertical,
          [Classes.SPACE_HORIZONTAL_WRAP]: wrap,
        })}
      />
    );
  }
}
